import { render, staticRenderFns } from "./ReportTab.vue?vue&type=template&id=048119c0"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports